/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Dialog, MediaButton } from "components";
import {
  ANALYTICS_EVENTS,
  ANALYTICS_GA_CATEGORIES,
} from "constants/analyticsKeys";
import { useAnalytics } from "context/analytics";
import { useModal } from "context/modal";

import "./GeoBlockedModal.scss";

export const GeoBlockedModal = () => {
  const { t } = useTranslation();
  const { dismissModal } = useModal();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent({
      name: ANALYTICS_EVENTS.GEOBLOCK_SHOWN,
      gaCategory: ANALYTICS_GA_CATEGORIES.ENGAGEMENT,
    });
  }, [trackEvent]);

  return (
    <Dialog
      wrapClassName="GeoBlockedModal"
      destroyOnClose
      footer={null}
      visible
      onCancel={dismissModal}
      closable={false}
      title={t("GEOBLOCKING__BLOCKED_ASSET")}
      titleHidden
    >
      <span className="GeoBlockedModal__Header">
        {t("GEOBLOCKING__BLOCKED_ASSET")}
      </span>
      <div className="GeoBlockedModal__Actions">
        <MediaButton type="button" variant="primary" onClick={dismissModal}>
          {t("GEOBLOCKING__POPUP_CANCEL")}
        </MediaButton>
      </div>
    </Dialog>
  );
};
